import React from 'react';

function Loading() {
  return (
    <div className="loading">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}

export default Loading;